export default __webpack_public_path__ + "static/media/YAS0700.34I-32686_-17888_50.02a57439.jpg";